module.exports = __webpack_public_path__ + "static/img/f5.e9cfddb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/f5.png
// module id = GOY7
// module chunks = 1